import { useParams } from 'react-router-dom';

import EventExperience from '../features/evento/layouts/experience';

// TSS vite/01 — thin page. Experiencia del participante del evento (QR → puja),
// PÚBLICA sin auth de sesión (capability-token en la URL). Mobile-first, dark,
// standalone (sin shell). Fases (intro → registro → landing → countdown → puja)
// las maneja la feature. La proyección del salón va en /evento/:token/pantalla.
export default function EventoPage() {
    const { token } = useParams();
    return <EventExperience token={token} />;
}
